import { Configuration, ProtocolMode, BrowserCacheLocation } from '@azure/msal-browser';
import { configuration$ } from '../configuration';

export const msalConfig$: Promise<Configuration> = (async function () {
    const conf = await configuration$;
    const msalConfig: Configuration = {
        auth: {
            clientId: 'phrospr_api',
            authority: conf.keycloakUrl,
            knownAuthorities: [conf.keycloakUrl.replace(/https?:\/\/([^\/]+)\/.*/, '$1')],
            protocolMode: ProtocolMode.OIDC,
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            // Process the redirect response in place at redirectUri. With the default (true),
            // MSAL defers processing to navigate back to the login-request URL and returns null
            // from handleRedirectPromise in the meantime; our bootstrap reads that null as
            // "no session" and fires a fresh loginRedirect, clobbering the code before it is
            // exchanged — an intermittent auth loop on first connect / logout / impersonation.
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
    };
    return msalConfig;
})();
